import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { usePrevious } from 'shared/hooks';
import { useFormErrorHandler } from '../hooks';

const FormErrorHandler = ({ errors, touched, serverError }) => {
  const [formErrors, setFormErrors] = useState(0);
  const { setErrorMessage, setErrorResolvedMessage } = useFormErrorHandler();
  const previousFormErrors = usePrevious(formErrors);

  useEffect(() => {
    // This component is sometimes only passed a serverError
    if (touched && errors) {
      const totalTouchedFields = Object.keys(touched).length;
      const totalErrors = Object.keys(errors).length;

      if (totalTouchedFields > 0) {
        setFormErrors(totalErrors);
      }
    }
  }, [touched, errors]);

  useEffect(() => {
    if (formErrors > 0) {
      setErrorMessage('Please review the form for errors');
    } else if (previousFormErrors > 0 && formErrors === 0) {
      setErrorResolvedMessage('All form errors have been fixed');
    }
  }, [setErrorMessage, formErrors, previousFormErrors, setErrorResolvedMessage]);

  useEffect(() => {
    if (serverError.length > 0) {
      setErrorMessage(serverError);
    }
  }, [serverError, setErrorMessage]);

  return null;
};

FormErrorHandler.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  serverError: PropTypes.string,
};

FormErrorHandler.defaultProps = {
  errors: null,
  touched: null,
  serverError: '',
};

export default FormErrorHandler;
